export const types = {
    GET_ROUTE_ALIAS: 'GET_ROUTE_ALIAS',
    GET_ROUTE_ALIAS_SUCCESS: 'GET_ROUTE_ALIAS_SUCCESS',
    GET_ROUTE_ALIAS_FAIL: 'GET_ROUTE_ALIAS_FAIL',
    GET_ALL_ROUTE_ALIASES: 'GET_ALL_ROUTE_ALIASES',
    GET_ALL_ROUTE_ALIASES_SUCCESS: 'GET_ALL_ROUTE_ALIASES_SUCCESS',
    GET_ALL_ROUTE_ALIASES_FAIL: 'GET_ALL_ROUTE_ALIASES_FAIL',
    CREATE_ROUTE_ALIAS: 'CREATE_ROUTE_ALIAS',
    CREATE_ROUTE_ALIAS_SUCCESS: 'CREATE_ROUTE_ALIAS_SUCCESS',
    CREATE_ROUTE_ALIAS_FAIL: 'CREATE_ROUTE_ALIAS_FAIL',
    UPDATE_ROUTE_ALIAS: 'UPDATE_ROUTE_ALIAS',
    UPDATE_ROUTE_ALIAS_SUCCESS: 'UPDATE_ROUTE_ALIAS_SUCCESS',
    UPDATE_ROUTE_ALIAS_FAIL: 'UPDATE_ROUTE_ALIAS_FAIL',
    DELETE_ROUTE_ALIAS: 'DELETE_ROUTE_ALIAS',
    DELETE_ROUTE_ALIAS_SUCCESS: 'DELETE_ROUTE_ALIAS_SUCCESS',
    DELETE_ROUTE_ALIAS_FAIL: 'DELETE_ROUTE_ALIAS_FAIL',
};

export interface IRouteAlias {
    _id: string;
    routePath: string;
    alternatePath: string;
    isActive: boolean;
    created_by: string;
    deleted: boolean;
    createdAt: string;
    updatedAt: string;
    id: string;
}

export interface IGetRouteAliasPayload {
    routePath: string;
}

export interface IGetAllRouteAliasesPayload {
    page?: number;
    limit?: number;
    searchTerm?: string;
}

export interface ICreateRouteAliasPayload {
    routePath: string;
    alternatePath: string;
}

export interface IUpdateRouteAliasPayload {
    id: string;
    routePath?: string;
    alternatePath?: string;
    isActive?: boolean;
}

export interface IDeleteRouteAliasPayload {
    id: string;
}

export interface IRouteAliasesResponse {
    status: string;
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    results: number;
    data: {
        data: IRouteAlias[];
    };
}
